import { Container } from 'unstated';

import { watchUserChange, watchUserInfo } from '../../services/authServices';

class AuthContainer extends Container {
  state = {
    authVerified: false,
    userAuthenticated: false,
    authenticatedUser: null,
    authenticatedUserInfo: null,
  };

  _userInfoUnsubscribe = null;

  _userChangeUnsubscribe = watchUserChange((user) => {
    if (user) {
      this.setState({
        authVerified: true,
        userAuthenticated: true,
        authenticatedUser: user,
        authenticatedUserInfo: null,
      });

      // watch user info change as soon as the user is authenticated
      this._userInfoUnsubscribe = watchUserInfo(
        (userInfo) => {
          if (userInfo) {
            this.setState({
              authenticatedUserInfo: {
                ...userInfo,
                email: user.email,
              },
            });
          }
        },
        { uid: user.uid },
      );
    } else {
      this.setState({
        authVerified: true,
        userAuthenticated: false,
        authenticatedUser: null,
        authenticatedUserInfo: null,
      });

      // remove subscribtion to user info change
      if (this._userInfoUnsubscribe) {
        this._userInfoUnsubscribe();
      }
    }
  });
}

export default AuthContainer;



// WEBPACK FOOTER //
// ./src/components/Auth/AuthContainer.js